module.exports = __webpack_public_path__ + "img/PackActive.9eca3621.svg";